<template lang="html">
  <div id="landingPage">
    <!-- <b-row id="row1">
      <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(1)" rounded><b-img fluid src="img/STP.png"></b-img></b-button></b-col>
      <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(2)"><b-img fluid src="img/ESK.png"></b-img></b-button></b-col>
      <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(3)"><b-img fluid src="img/PYM.png"></b-img></b-button></b-col>
    </b-row> -->
    <br>
    <br>
    <br>
    <!-- <br>
    <br> -->
    <!-- <br>
    <br>
    <br> -->
    <!-- <b-row id="row2">
      <b-col lg="2" class=""></b-col>
      <b-col lg="3" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(1)"><b-img fluid src="img/TOW.png"></b-img></b-button></b-col>
      <b-col lg="2" class=""></b-col>
      
      <b-col lg="3" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(2)"><b-img fluid src="img/UNA.png"></b-img></b-button></b-col>
    </b-row> -->
    <b-row class="rowTest">
      <b-col lg="1" class=""></b-col>
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(1)"><b-img fluid src="img/DigitalWeek2020.png"></b-img></b-button></b-col>
      <!-- <b-col lg="1" class=""></b-col> -->
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(2)"><b-img fluid src="img/DetailedDemoVideo.png"></b-img></b-button></b-col>
      <b-col lg="2" class=""></b-col>
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(4)"><b-img fluid src="img/CanleyVale.png"></b-img></b-button></b-col>
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(5)"><b-img fluid src="img/JervisBayInterchange.png"></b-img></b-button></b-col>
    </b-row>
    <br>
    <br>
    <b-row class="rowTest">
      <b-col lg="1" class=""></b-col>
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(3)"><b-img fluid src="img/PresentationRecording.png"></b-img></b-button></b-col>
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="" href="https://forms.office.com/Pages/ResponsePage.aspx?id=fQWQf6A-_kawfOBWhicIG4joWlHVgNZBoOg2AAFzZyJUNUhMRjNQV0NSU1NGSUJGR09EU0pFMjRJMy4u" target="_blank"><b-img fluid src="img/ContactUs.png" style="margin-top:2.8vh;"></b-img></b-button></b-col>
      <b-col lg="2" class=""></b-col>
      
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(6)"><b-img fluid src="img/OtfordTunnel.png"></b-img></b-button></b-col>
      <b-col lg="2" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(7)"><b-img fluid src="img/AnitaStreet.png"></b-img></b-button></b-col>

      
    </b-row>
    <!-- <div class="row" id="row1">
      <div class="col-1">

      </div>
      <div class="col-3">
        ts
      </div>
      <div class="col-3">
        st
      </div>
      <div class="col-3">

      </div>
      <div class="col-1">

      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  methods: {
    buttonClicked: function(id) {
      // console.log(id);
      // console.log(this.$router);
      this.$router.push({ name: 'MainApp', params: { activeTab: id } })
    }
  }
}
</script>

<style>
  #landingPage {
    width: 100vw;
    height: 87vh!important;
    
    /* background-color: green; */
  }
  #row1 {
    height: 43vh;
  }
  #row2 {
    height: 43vh;
  }
  .rowTest {
    height: 30vh;
  }
  .bigButton {
    margin-top: 6vh;
    width: 15vw!important;
    height: 25vh!important;
    background: rgba(129, 129, 129, 0.5);
    box-shadow: 0 4px 8px 0 rgba(24, 21, 29, 0.2), 0 6px 20px 0 rgba(24, 21, 29, 0.19);
  }
  .bigButton:hover, .bigButton:active {
    background: rgba(129, 129, 129, 0.6)!important;
  }
</style>
